import { Input } from '@mm/components';
import { useWebsiteReportSummaryActions } from '@mm/state/actions/WebsiteReportSummaryActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { ClarifyWebsiteTrafficModalProps } from '@mm/state/modules/modalsState/props';
import { MODALS_TYPE } from '@mm/state/modules/modalsState/types';
import { trafficTotalSelector } from '@mm/state/selectors/websiteReportSummarySelector';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import styles from './ClarifyWebsiteTraffic.module.css';
import { TRAFFIC_SUM_TRESHOLD } from '../hooks/constants';

export const ClarifyWebsiteTraffic = ({
  website,
  openSignupModal,
}: ClarifyWebsiteTrafficModalProps) => {
  const [organicTraffic, setOrganicTraffic] = useState<string | undefined>(
    undefined,
  );
  const [paidTraffic, setPaidTraffic] = useState<string | undefined>(undefined);
  const { closeModal } = useModalActions();
  const { setTrafficTotals } = useWebsiteReportSummaryActions();
  const totalTraffic = useSelector(trafficTotalSelector);
  const setTraffic = () => {
    const newTraffic = { ...totalTraffic };
    if (!newTraffic.trafficType) {
      newTraffic.trafficType = {};
    }

    newTraffic.trafficType.organic = parseFloat(organicTraffic || '');
    newTraffic.trafficType.paid = parseFloat(paidTraffic || '');
    setTrafficTotals(newTraffic);
  };

  useEffect(() => {
    setTraffic();
  }, [organicTraffic, paidTraffic]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.heading}>We need a little more information </div>
        <div className={styles.subheader}>
          To determine if we are able to, and how many leads we can capture from
          the web traffic for{' '}
          <span className={styles.subheader}>{website}</span>
        </div>
      </div>

      <div className={styles.form}>
        <div className={styles.formBlock}>
          <div className={styles.title}>
            Your organic traffic
            <span className={styles.note}>(last 30 days)</span>
          </div>
          <Input
            type="text"
            css={{ container: styles.input }}
            placeholder="5,000"
            value={organicTraffic}
            onChange={e => {
              const number = e.target.value.match(/[0-9]+/)?.toString();
              setOrganicTraffic(number);
            }}
          />
        </div>
        <div className={styles.formBlock}>
          <div className={styles.title}>
            Your paid traffic
            <span className={styles.note}>(last 30 days)</span>
          </div>
          <Input
            type="text"
            css={{ container: styles.input }}
            placeholder="1,000"
            value={paidTraffic}
            onChange={e => {
              const number = e.target.value.match(/[0-9]+/)?.toString();
              setPaidTraffic(number);
            }}
          />
        </div>
      </div>

      <div className={styles.actions}>
        <PrimaryButton
          className={styles.button}
          disabled={!organicTraffic || !paidTraffic}
          onClick={() => {
            if (
              Number(organicTraffic) + Number(paidTraffic) <
              TRAFFIC_SUM_TRESHOLD
            ) {
              openSignupModal();
            }
            closeModal(MODALS_TYPE.CLARIFY_WEBSITE_TRAFFIC_MODAL);
          }}
        >
          Get my report now
        </PrimaryButton>
        <div className={styles.subheader} onClick={() => openSignupModal()}>
          Don’t have this information?
        </div>
      </div>
    </div>
  );
};
